module.exports = __webpack_public_path__ + "media/images/corporate-sales/icons/promo-86efe9cc42209c10d28d1ec1d2e56bb6.svg";